import { render, staticRenderFns } from "./companys-add.vue?vue&type=template&id=14dbbb0c&"
import script from "./companys-add.vue?vue&type=script&lang=js&"
export * from "./companys-add.vue?vue&type=script&lang=js&"
import style0 from "./companys-add.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports